const NoBooksMessage = ({ translations, noCoursesImage }) => (
    <div className="flex flex-col items-center justify-center h-screen text-center p-4 mt-[-10%]">
      <img src={noCoursesImage} alt="No books available" className="w-60 h-60 object-cover" />
      <p className="text-lg text-gray-700" style={{ fontFamily: "Tajwal, sans-serif" }}>
        {translations.no_books_message}
      </p>
    </div>
  );
  
  export default NoBooksMessage;
  